import React, { useContext, useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { toast } from 'react-toastify'
import { Auth } from '../../../../../contexts/allContext'
import { apiV1, apiV2 } from '../../../../../utils/api'
import PopupV1 from '../../../../Resources/PopupV1/PopupV1'
import classes from './Popup.module.css'

export default function Popup({
    setForm,
    form,
    productId,
    singleProduct,
    setProductActive,
    productActive,
    setIsDisable,
    isDisable,
}) {
    const { stateAuth } = useContext(Auth)
    const token = stateAuth?.token

    const toastSuccess = () => {
        toast.dismiss()
        toast.success('Product Status updated!', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const toastSuccessDisabled = () => {
        toast.dismiss()
        toast.success('Product Delete Successfully', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const toastError = () => {
        toast.dismiss()
        toast.error('Product delete permanently!', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        })
    }

    const handleStatusChange = async (status) => {
        try {
            const response = await fetch(`${apiV2}/products/product/${productId}`, {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ is_active: status }),
            })

            if (response.ok) {
                console.log('Success: Product status updated')
                setProductActive(!productActive)
                toastSuccess()
            } else {
                console.log('Error: Something went wrong!')
            }
        } catch (error) {
            console.error('Request failed:', error)
        }
    }

    const handleStatusDisabled = async (status) => {
        try {
            const response = await fetch(`${apiV1}/admin/product/disable/${productId}`, {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            if (response.ok) {
                console.log('Success: Product status updated')
                setProductActive(!productActive)
                toastSuccessDisabled()
            } else {
                console.log('Error: Something went wrong!')
            }
        } catch (error) {
            console.error('Request failed:', error)
        }
    }

    const handleDeletePermanent = async (status) => {
        try {
            const response = await fetch(`${apiV2}/products/permanent/delete/${productId}`, {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            if (response.ok) {
                console.log('Success: Product deleted')
                setProductActive(!productActive)
                toastError()
            } else {
                console.log('Error: Something went wrong!')
            }
        } catch (error) {
            console.error('Request failed:', error)
        }
    }

    return (
        <div className={classes.container}>
            <PopupV1 setForm={setForm} form={form} width="30%">
                <div className={classes.close}>
                    <div className={classes.closeIcon}>
                        <p onClick={() => setForm(!form)}>
                            <IoClose size={20} />
                        </p>
                    </div>
                    <div className={classes.header}>
                        <p>Update Product Status</p>
                    </div>
                </div>
                {!isDisable ? (
                    <div className={classes.btns}>
                        <button
                            onClick={() => {
                                handleStatusChange(true)
                            }}
                            className={classes.activebtn}>
                            Active
                        </button>
                        <button
                            onClick={() => {
                                handleStatusDisabled()
                            }}
                            className={classes.cancelbtn}>
                            Delete
                        </button>
                    </div>
                ) : (
                    <div className={classes.btns}>
                        <button
                            onClick={() => {
                                handleStatusDisabled()
                            }}
                            className={classes.activebtn}>
                            Restore
                        </button>
                        <button
                            onClick={() => {
                                handleDeletePermanent()
                            }}
                            className={classes.cancelbtn}>
                            Permarnent Delete
                        </button>
                    </div>
                )}
            </PopupV1>
        </div>
    )
}
